<se-fe-card>
  <se-fe-card-header
    seFeDataTitle="Feature: Remove Persona Modal"
    seFeDataSubtitle="Modal confirming removal of persona, followed by persona deletion"
  ></se-fe-card-header>
  <se-fe-card-content>
    <p>Use in MySe Households or in other places where we remove profiles</p>
  </se-fe-card-content>
</se-fe-card>

<se-fe-card>
  <se-fe-card-header seFeDataTitle="Example Code"></se-fe-card-header>
  <se-fe-card-content>
    <se-po-remove-persona-modal-example></se-po-remove-persona-modal-example>
  </se-fe-card-content>
</se-fe-card>
